(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      /*
       * Two independent questions, which stock Sense conflated into one flag:
       *
       *   headerIsAlwaysSticky  — is the bar pinned from the very top of the page?
       *   headerYieldsOnScroll  — does it get out of the way while the customer scrolls down?
       *
       * Sense only let a merchant have one or the other. 'always' pinned the bar and disabled
       * hide/reveal outright, so it ate vertical space for the whole session; 'on-scroll-up'
       * gave hide/reveal but left the bar unpinned until you scrolled back up. Moonglaze does
       * both at once (base.js HeaderComponent.hideHeaderOnScroll) and that is the target, so
       * 'always' now means pinned AND yielding.
       *
       * This is safe because hiding does not unstick anything: base.css:2340 moves the bar by
       * `top`, and base.css:2335 keeps `position: sticky` throughout. Pinned-and-hidden is a
       * real state, which is exactly what Moonglaze's `hide-header` class is.
       *
       * 'reduce-logo-size' keeps stock behaviour — pinned, never yields — because its whole
       * point is staying visible while it shrinks.
       */
      const stickyType = this.getAttribute('data-sticky-type');
      this.headerIsAlwaysSticky = stickyType === 'always' || stickyType === 'reduce-logo-size';
      this.headerYieldsOnScroll = stickyType === 'always' || stickyType === 'on-scroll-up';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (!this.headerYieldsOnScroll) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this.headerYieldsOnScroll) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    // Back at the top of the page. An always-sticky header stays stuck here — dropping the
    // sticky class would unpin it and make the bar jump, which is the bug this guard prevents.
    reset() {
      if (!this.headerYieldsOnScroll) return;
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
      if (!this.headerIsAlwaysSticky) {
        this.header.classList.remove('shopify-section-header-sticky');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
